import type { PropsWithChildren } from 'react';
import { tableHeaderCellStyle } from '~/_shared/baseComponents/table/table.styles';

type TableHeaderCellProps = PropsWithChildren<{
  readonly className?: string;
  readonly colSpan?: number;
}>;

export const TableHeaderCellComponent = ({ className, children, colSpan = 1 }: TableHeaderCellProps) => {
  return (
    <div
      className={className}
      css={tableHeaderCellStyle({ colSpan })}
    >
      {children}
    </div>
  );
};
